import { render, staticRenderFns } from "./yesRadar.vue?vue&type=template&id=3632e3ab&scoped=true"
import script from "./yesRadar.vue?vue&type=script&lang=js"
export * from "./yesRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632e3ab",
  null
  
)

export default component.exports